/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APICustomerSearchResult } from './APICustomerSearchResult';
import {
    APICustomerSearchResultFromJSON,
    APICustomerSearchResultFromJSONTyped,
    APICustomerSearchResultToJSON,
} from './APICustomerSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APICustomerSearchResponse
 */
export interface APICustomerSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APICustomerSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APICustomerSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APICustomerSearchResult>}
     * @memberof APICustomerSearchResponse
     */
    results: Array<APICustomerSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APICustomerSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APICustomerSearchResponse interface.
 */
export function instanceOfAPICustomerSearchResponse(value: object): value is APICustomerSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APICustomerSearchResponseFromJSON(json: any): APICustomerSearchResponse {
    return APICustomerSearchResponseFromJSONTyped(json, false);
}

export function APICustomerSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APICustomerSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APICustomerSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APICustomerSearchResponseToJSON(value?: APICustomerSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APICustomerSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

